/* Inklapbare footerkolommen op mobiel.
 *
 * Het thema levert de footer als kale koppen met een lijst eronder: geen
 * details/summary, geen aria, dus met CSS alleen valt er niets open te klappen.
 * Dit script maakt van elke kop een echte knop en koppelt die aan de inhoud.
 *
 * Uitgangspunten:
 * - Progressive enhancement. Draait dit script niet, dan staat de footer
 *   gewoon open. Er gaat nooit inhoud verloren.
 * - Alleen onder 750px. Op desktop blijft alles zoals het was, inclusief het
 *   verwijderen van de knoppen als je het venster groter maakt.
 * - Idempotent. cd-vars wordt door elke cd-sectie gerenderd, dus dit bestand
 *   kan meerdere keren in de pagina staan; de vlag hieronder voorkomt dat de
 *   koppen dubbel worden omgebouwd.
 */
(function () {
  if (window.__cdFooterCollapse) return;
  window.__cdFooterCollapse = true;

  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var omgebouwd = [];

  function kolommen() {
    var blokken = Array.prototype.slice.call(document.querySelectorAll('.footer-block'));
    return blokken.map(function (blok) {
      var kop = blok.querySelector('.footer-block__heading');
      if (!kop) return null;
      var inhoud = kop.nextElementSibling;
      if (!inhoud) return null;

      /* Een blok zonder eigen kop dat direct onder een kop staat, hoort visueel
         bij die kop; denk aan adresgegevens onder "Kontakt". Die klappen dus mee
         open en dicht. We stoppen bij het eerste blok met een formulier, want een
         nieuwsbriefblok is een zelfstandig onderdeel en geen onderdeel van de kolom. */
      var extra = [];
      var volgende = blokken[blokken.indexOf(blok) + 1];
      while (volgende &&
             !volgende.querySelector('.footer-block__heading') &&
             !volgende.querySelector('form')) {
        extra.push(volgende);
        volgende = blokken[blokken.indexOf(volgende) + 1];
      }

      return { blok: blok, kop: kop, inhoud: inhoud, extra: extra };
    }).filter(Boolean);
  }

  function bouwOm(k, index) {
    if (k.blok.dataset.cdCollapse) return;

    var label = k.kop.textContent.trim();
    if (!label) return;

    var id = 'cd-footer-paneel-' + index;
    k.inhoud.id = k.inhoud.id || id;
    k.inhoud.classList.add('cd-footer__paneel');

    var knop = document.createElement('button');
    knop.type = 'button';
    knop.className = 'cd-footer__knop';
    knop.setAttribute('aria-expanded', 'false');
    knop.setAttribute('aria-controls', k.inhoud.id);
    knop.innerHTML = '<span>' + label + '</span><span class="cd-footer__chev" aria-hidden="true"></span>';

    k.kop.textContent = '';
    k.kop.appendChild(knop);
    k.blok.dataset.cdCollapse = 'dicht';
    k.blok.classList.add('cd-footer__blok');

    k.extra.forEach(function (e) {
      e.classList.add('cd-footer__extra');
      e.dataset.cdCollapse = 'dicht';
    });

    function wissel() {
      var open = k.blok.dataset.cdCollapse === 'open';
      var nieuw = open ? 'dicht' : 'open';
      k.blok.dataset.cdCollapse = nieuw;
      k.extra.forEach(function (e) { e.dataset.cdCollapse = nieuw; });
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
    }

    knop.addEventListener('click', wissel);
    omgebouwd.push({ k: k, knop: knop, label: label, wissel: wissel });
  }

  function draaiTerug() {
    omgebouwd.forEach(function (o) {
      o.knop.removeEventListener('click', o.wissel);
      o.k.kop.textContent = o.label;
      o.k.inhoud.classList.remove('cd-footer__paneel');
      o.k.blok.classList.remove('cd-footer__blok');
      delete o.k.blok.dataset.cdCollapse;
      o.k.extra.forEach(function (e) {
        e.classList.remove('cd-footer__extra');
        delete e.dataset.cdCollapse;
      });
    });
    omgebouwd = [];
  }

  function pasToe() {
    if (MQ && MQ.matches) {
      if (!omgebouwd.length) kolommen().forEach(bouwOm);
    } else if (omgebouwd.length) {
      draaiTerug();
    }
  }

  function start() {
    pasToe();
    if (MQ) {
      if (MQ.addEventListener) MQ.addEventListener('change', pasToe);
      else if (MQ.addListener) MQ.addListener(pasToe);
    }
    /* Vangnet: niet elke omgeving vuurt het change-event van matchMedia bij een
       programmatische venstergrootte. Resize is een goedkope tweede kans. */
    var wacht = null;
    window.addEventListener('resize', function () {
      if (wacht) clearTimeout(wacht);
      wacht = setTimeout(pasToe, 150);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // de theme editor herrendert secties; footerblokken kunnen dan vervangen zijn
  document.addEventListener('shopify:section:load', function () {
    omgebouwd = [];
    pasToe();
  });
})();
